import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useMemo, useState } from "react";
import * as MuiIcons from "@mui/icons-material";

export interface TypeImages {
    imgUrl?: string;
    blob?: Blob;
    base64?: string;
}
interface Props {
    open: boolean;
    onClose: () => void;
    images: TypeImages[];
}
const PhotoGallery = (props: Props) => {
    const [activeStep, setActiveStep] = useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const images = useMemo<TypeImages[]>(() => {
        return props.images.map((img) => {
            if (img.blob) {
                const urlCreator = window.URL || window.webkitURL;
                const imageUrl = urlCreator.createObjectURL(img.blob);
                return {
                    imgUrl: imageUrl,
                };
            } else if (img.base64) {
                return {
                    imgUrl: `data:image/png;base64,${img.base64}`,
                }
            } else {
                return img;
            }
        });
    }, [props.images]);

    return(
        <Mui.Dialog
            open={props.open}
            onClose={props.onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                style: {
                    backgroundColor: "transparent",
                    boxShadow: "none"
                }
            }}
        >
			<Mui.DialogTitle style={{borderBottom: "0px"}}>
                <Mui.Grid container columnSpacing={1}  >
                
                    <Mui.Grid item xs="auto" marginLeft="auto">
                        <Mui.IconButton onClick={props.onClose}>
                        <MuiIcons.Close />
                        </Mui.IconButton>
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>

            <Mui.DialogContent  
                
                sx={{backgroundColor: "white", maxWidth: "90%"}}>
                <Mui.Stack direction="row" justifyContent="center">
                    <Mui.Stack justifyContent="center">
                        <Mui.Button 
                            variant="text" 
                            sx={{
                                backgroundColor: "white", 
                                marginRight: "10px", 
                                borderRadius: "15px"
                            }} 
                            size="icon" 
                            onClick={handleBack} 
                            disabled={activeStep === 0}
                        >
                            {<KeyboardArrowLeft />}
                        </Mui.Button>
                    </Mui.Stack>

                    <Mui.Box justifyContent="center">
                        {images.map((step, index) => {
                            console.log("step", step);

                            return (
                                <div key={`photo-gallery-image-${index}`} style={{paddingTop: "5%", textAlign: "center"}}>
                                    {Math.abs(activeStep - index) <= 0 ? (
                                        // eslint-disable-next-line jsx-a11y/alt-text
                                        <img src={step.imgUrl} style={{ maxWidth: "90%", maxHeight: "90%"}} />
                                    ) : null}
                                </div>
                            );
                        })}
                        <Mui.MobileStepper
                            steps={images.length}
                            position="static"
                            variant="dots"
                            activeStep={activeStep}
                            nextButton={<div />}
                            backButton={<div />}
                            sx={{backgroundColor: "transparent"}}
                        />      
                    </Mui.Box>

                    <Mui.Stack justifyContent="center">
                        <Mui.Button 
                            variant="text" 
                            style={{
                                backgroundColor: "white", 
                                marginLeft: "10px", 
                                borderRadius: "15px"
                            }} 
                            size="icon" 
                            onClick={handleNext} 
                            disabled={activeStep === images.length - 1}>
                            {<KeyboardArrowRight />}
                        </Mui.Button>
                    </Mui.Stack>
                </Mui.Stack>
            </Mui.DialogContent>
        </Mui.Dialog>
    )
}
export default PhotoGallery;